export const apiVehicleTypeRoutes = {
  routeTypeVehicles: 'driver/typevehicles',
  routeChangeTypeVehicleState: ''
};